module.exports = __webpack_public_path__ + "static/dog@2x-3eee281091cb7a09b130f35c9dcaa4ff.png";